import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["fileInput", "emptyState", "filledState", "preview", "urlInput"];

  connect() {
    const url = this.urlInputTarget.value;
    if (url) {
      this.showPreview(url);
    } else {
      this.showEmpty();
    }
  }

  showEmpty() {
    this.emptyStateTarget.classList.remove('hidden');
    this.filledStateTarget.classList.add('hidden');
  }

  showPreview(url) {
    this.previewTarget.src = url;
    this.filledStateTarget.classList.remove('hidden');
    this.emptyStateTarget.classList.add('hidden');
  }

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  handleFileChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = '';

    const formData = new FormData();
    formData.append('file', file);

    fetch('/dashboard/shared/image_uploads', {
      method: 'POST',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: formData,
    })
      .then(r => r.json())
      .then(data => { if (data?.url) this.setUrl(data.url); })
      .catch(() => {});
  }

  setUrl(url) {
    this.urlInputTarget.value = url;
    this.showPreview(url);
    this.urlInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.urlInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  removeImage() {
    this.urlInputTarget.value = '';
    this.showEmpty();
    this.urlInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.urlInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
